import React from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2, BookOpen, Eye, Users, Smartphone, MapPin, XCircle } from 'lucide-react';
export const UniqueMechanism = () => {
  return <section className="py-12 md:py-20 px-4 bg-gold/5 border-y border-gold/20 relative overflow-hidden" data-id="element-44">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-2xl h-1 bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-45"></div>
      <div className="max-w-4xl mx-auto text-center" data-id="element-46">
        <FadeIn data-id="element-47">
          <span className="text-gold font-inter tracking-widest uppercase text-sm font-bold mb-3 block" data-id="element-48">
            El Secreto Revelado
          </span>
          <h3 className="font-playfair text-3xl md:text-5xl mb-5 md:mb-8" data-id="element-49">
            The Exotic Reframe
            <br data-id="element-50" />
            <span className="text-xl md:text-3xl text-gray-400 mt-1 block" data-id="element-51">
              (El Reencuadre Exótico)
            </span>
          </h3>
          <p className="font-inter text-gray-300 text-base md:text-xl leading-relaxed max-w-3xl mx-auto" data-id="element-52">
            Este método no te enseña inglés; te enseña a usar el silencio, la
            mirada y el "Broken English" para crear una tensión sexual
            insoportable. Aprendes a convertir una palabra mal pronunciada en
            una excusa para que ella se acerque a tu cara, y a usar tu origen
            como un símbolo de estatus, aventura y misterio que ningún gringo
            puede replicar.
          </p>
        </FadeIn>
      </div>
    </section>;
};
export const WhatYouGet = () => {
  const items = [{
    icon: <BookOpen className="w-7 h-7 md:w-8 md:h-8 text-gold" data-id="element-53" />,
    title: 'El Manual Maestro (eBook PDF)',
    desc: 'La estrategia completa de psicología de contraste.'
  }, {
    icon: <Eye className="w-7 h-7 md:w-8 md:h-8 text-gold" data-id="element-54" />,
    title: 'Protocolo de Lenguaje No Verbal',
    desc: 'Cómo dominar cualquier lugar sin decir una sola palabra.'
  }, {
    icon: <Users className="w-7 h-7 md:w-8 md:h-8 text-gold" data-id="element-55" />,
    title: "Técnica 'Come Closer'",
    desc: 'El truco exacto para que ella invada tu espacio personal cuando no entiendes algo.'
  }, {
    icon: <MapPin className="w-7 h-7 md:w-8 md:h-8 text-gold" data-id="element-56" />,
    title: "Guía de Cierre en 'Spanglish'",
    desc: 'Cómo llevarla del encuentro a tu casa usando liderazgo puro.'
  }, {
    icon: <Smartphone className="w-7 h-7 md:w-8 md:h-8 text-gold" data-id="element-57" />,
    title: 'Auditoría de Perfil USA',
    desc: 'Cómo configurar tu Instagram para atraer americanas mientras duermes.'
  }];
  return <section className="py-12 md:py-20 px-4" data-id="element-58">
      <div className="max-w-4xl mx-auto" data-id="element-59">
        <FadeIn data-id="element-60">
          <h3 className="font-playfair text-3xl md:text-4xl text-center mb-8 md:mb-16" data-id="element-61">
            Lo que obtienes hoy
          </h3>
          <div className="grid gap-4 md:gap-6 md:grid-cols-2" data-id="element-62">
            {items.map((item, index) => <div key={index} className={`p-4 md:p-6 rounded-lg bg-dark-card border border-dark-border hover:border-gold/50 transition-colors ${index === 4 ? 'md:col-span-2 md:max-w-md md:mx-auto' : ''}`} data-id="element-63">
                <div className="flex items-center md:flex-col md:items-center md:text-center gap-3 md:gap-4" data-id="element-64">
                  <div className="p-2 md:p-3 rounded-full bg-gold/10 flex-shrink-0" data-id="element-65">
                    {item.icon}
                  </div>
                  <div data-id="element-66">
                    <h4 className="font-playfair text-lg md:text-xl font-bold text-white mb-1 md:mb-2" data-id="element-67">
                      {item.title}
                    </h4>
                    <p className="font-inter text-gray-400 text-sm md:text-base" data-id="element-68">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const WhoIsFor = () => {
  const isFor = ['Latinos trabajadores en EE.UU. que se sienten solos.', 'Hombres que tienen un inglés básico o nulo pero quieren resultados ya.', "Inmigrantes que quieren subir su estatus social y no ser vistos 'solo como trabajadores'.", "Solteros que están cansados de que les dejen en 'visto' en las apps."];
  const notFor = ['Hombres que buscan un curso de gramática o inglés académico.', 'Personas que tienen miedo de mirar a una mujer a los ojos.', 'Hombres que prefieren seguir quejándose de su soledad en lugar de actuar.'];
  return <section className="py-12 md:py-20 px-4 bg-dark-card" data-id="element-69">
      <div className="max-w-5xl mx-auto" data-id="element-70">
        <div className="grid md:grid-cols-2 gap-6 md:gap-12" data-id="element-71">
          <FadeIn data-id="element-72">
            <div className="p-5 md:p-8 rounded-xl border border-green-900/30 bg-black/40" data-id="element-73">
              <h3 className="font-playfair text-xl md:text-2xl text-white mb-5 md:mb-8 flex items-center gap-3" data-id="element-74">
                <CheckCircle2 className="text-green-500 w-7 h-7 md:w-8 md:h-8 flex-shrink-0" data-id="element-75" />
                ESTO ES PARA TI SI...
              </h3>
              <ul className="space-y-4 md:space-y-6" data-id="element-76">
                {isFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-77">
                    <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-78" />
                    <span className="font-inter text-gray-300 text-sm md:text-base" data-id="element-79">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-80">
            <div className="p-5 md:p-8 rounded-xl border border-red-900/30 bg-black/40" data-id="element-81">
              <h3 className="font-playfair text-xl md:text-2xl text-white mb-5 md:mb-8 flex items-center gap-3" data-id="element-82">
                <XCircle className="text-red-500 w-7 h-7 md:w-8 md:h-8 flex-shrink-0" data-id="element-83" />
                ESTO NO ES PARA TI SI...
              </h3>
              <ul className="space-y-4 md:space-y-6" data-id="element-84">
                {notFor.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-85">
                    <XCircle className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-86" />
                    <span className="font-inter text-gray-300 text-sm md:text-base" data-id="element-87">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
};